export function getSocialUsername(url: string, platform: string): string {
  if (!url) return "";

  const stripHttps = url.includes("https://");

  switch (platform) {
    case "facebook":
      return stripHttps
        ? url.replace(/https?:\/\/(www\.)?facebook\.com\//g, "")
        : url.replace(/(www\.)?facebook\.com\//g, "");
    case "linkedin":
      return stripHttps
        ? url.replace(/https?:\/\/(www\.)?linkedin\.com\/in\//g, "")
        : url.replace(/(www\.)?linkedin\.com\/in\//g, "");
    case "github":
      return stripHttps
        ? url.replace(/https?:\/\/(www\.)?github\.com\//g, "")
        : url.replace(/(www\.)?github\.com\//g, "");
    case "instagram":
      return stripHttps
        ? url.replace(/https?:\/\/(www\.)?instagram\.com\//g, "")
        : url.replace(/(www\.)?instagram\.com\//g, "");
    case "email":
      return url;
    default:
      return url;
  }
}

export function hasSocialLinks(user: {
  linkedin?: string | null;
  github?: string | null;
  facebook?: string | null;
  instagram?: string | null;
}): boolean {
  return Boolean(user.linkedin || user.github || user.facebook || user.instagram);
}
